import {createSlice, current} from "@reduxjs/toolkit";

const STORAGE_KEY = 'bookera:no-show-customers:v2'

// No-show marks are kept in the admin's browser: they show up immediately and
// survive a reload even before the customers list is refetched. Marks are
// grouped by company, matching the API, where a no-show at one location shows
// at every location of the same company. An entry here wins over the flag the
// API reports, so clearing a mark keeps working.
const readMarks = () => {
    if (typeof window === 'undefined') return {};

    try {
        return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) ?? {}
    } catch {
        return {}
    }
}

const writeMarks = (marks) => {
    if (typeof window === 'undefined') return;

    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(marks))
    } catch {}
}

const setMark = (state, companyId, customerId, mark) => {
    if (!companyId || !customerId) return;

    const companyKey = String(companyId)

    state.marks[companyKey] = {
        ...(state.marks[companyKey] ?? {}),
        [String(customerId)]: mark,
    }

    writeMarks(current(state.marks))
}

export const noShowSlice = createSlice({
    name: 'noShow',
    initialState: {
        marks: {},
        isHydrated: false,
    },
    reducers: {
        hydrateNoShowMarks(state) {
            state.marks = readMarks()
            state.isHydrated = true
        },
        markCustomerNoShow(state, {payload}) {
            const {companyId, customerId, reason} = payload

            setMark(state, companyId, customerId, {
                no_show: true,
                reason: reason || null,
                updated_at: new Date().toISOString(),
            })
        },
        clearCustomerNoShow(state, {payload}) {
            const {companyId, customerId} = payload

            // Stored as an explicit "not a no-show" instead of a delete, so a
            // flag coming back from the API stays hidden after the admin
            // removed the badge.
            setMark(state, companyId, customerId, {
                no_show: false,
                reason: null,
                updated_at: new Date().toISOString(),
            })
        },
    },
})

export const {hydrateNoShowMarks, markCustomerNoShow, clearCustomerNoShow} = noShowSlice.actions

export const selectNoShowMarks = (state) => state.noShow.marks
export const selectNoShowHydrated = (state) => state.noShow.isHydrated
